<div class="dialog">
  <h1>
    {{ failedUploads.length }} Failed
    @if (failedUploads.length !== 1) {
      Uploads
    } @else {
      Upload
    }
  </h1>
  <div class="failed-uploads">
    @for (upload of failedUploads; track upload) {
      <app-upload-item
        [generatePreview]="true"
        [upload]="upload"
        [gallery]="gallery"
        [preventDismiss]="true"
      ></app-upload-item>
    }
  </div>
  <button
    appButton
    name="confirm"
    location="failed-uploads-dialog"
    color="primary"
    spacing="full"
    shape="round"
    size="3"
    height="4"
    (click)="dismiss()"
  >
    Dismiss
    @if (failedUploads.length > 1) {
      All
    }
  </button>
</div>
